<div *transloco="let t" class="pt-4">
	<div @fadeInUp [formGroup]="filterFormGroup" class="overflow-auto flex flex-row justify-start items-start">
		<div class="flex flex-row justify-start items-start flex-[25%]">
			<div class="list-background w-full">
				<div class="bg-card rounded-full border px-4 bg-white md:w-auto flex flex-row justify-start items-center">
					<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
					<input
						#input
						[delayedSearch]="searchFilterSubject"
						class="px-4 py-3 border-0 outline-none w-full bg-white"
						matInput
						name="searchField"
						placeholder="{{ t('commonActions.search') }}"
						type="search" />
				</div>
				<div class="flex flex-row gap-4 px-2 pt-2">
					<mat-form-field class="flex-1" appearance="outline">
						<mat-label>{{ t('tenantunitDetails.details.validFrom') }}</mat-label>
						<input matInput [matDatepicker]="fromPicker" formControlName="validFrom" width="85%" />
						<div matSuffix class="flex items-center">
							@if (filterFormGroup.get('validFrom').value) {
								<mat-datepicker-toggle>
									<mat-icon
										matDatepickerToggleIcon
										(click)="filterFormGroup.get('validFrom').setValue(null)"
										(keyup)="filterFormGroup.get('validFrom').setValue(null)">
										clear
									</mat-icon>
								</mat-datepicker-toggle>
							}
							<mat-datepicker-toggle [for]="fromPicker"></mat-datepicker-toggle>
						</div>
						<mat-datepicker #fromPicker></mat-datepicker>
					</mat-form-field>

					<mat-form-field class="flex-1" appearance="outline">
						<mat-label>{{ t('tenantunitDetails.details.validTo') }}</mat-label>
						<input matInput [matDatepicker]="toPicker" formControlName="validTo" width="85%" />
						<div matSuffix class="flex items-center">
							@if (filterFormGroup.get('validTo').value) {
								<mat-datepicker-toggle>
									<mat-icon
										matDatepickerToggleIcon
										(click)="filterFormGroup.get('validTo').setValue(null)"
										(keyup)="filterFormGroup.get('validTo').setValue(null)">
										clear
									</mat-icon>
								</mat-datepicker-toggle>
							}
							<mat-datepicker-toggle [for]="toPicker"></mat-datepicker-toggle>
						</div>
						<mat-datepicker #toPicker></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="flex flex-row px-2 justify-between items-start">
					<div class="flex-1">
						<div class="flex flex-row items-center">
							<label id="user-roles-radio-group-label" class="text-base font-medium">{{ t('billing.filterUserRole') }}</label>
							@if (showAddUserRoleButton()) {
								<button (click)="addUserRole()" mat-icon-button color="primary" [matTooltip]="t('billing.addUserRole')">
									<mat-icon>add</mat-icon>
								</button>
							}
						</div>
						<mat-radio-group formControlName="userRole" class="flex flex-col" aria-labelledby="user-roles-radio-group-label">
							<div class="flex flex-row">
								<mat-radio-button [value]="UserRoleTypeExtensionEnum.BILLING_UNIT">{{ t('billing.tenant') }}</mat-radio-button>
							</div>
							@for (availableUserRole of availableUserRoles(); track availableUserRole.exportId) {
								<div class="flex flex-row items-center justify-between">
									<mat-radio-button [value]="availableUserRole.userRoleType">
										{{ t('enum.' + availableUserRole.userRoleType) }}
										@if (
											availableUserRole.name?.trim()?.length &&
											t('enum.' + availableUserRole.userRoleType) !== availableUserRole.name?.trim()
										) {
											({{ availableUserRole.name }})
										}
									</mat-radio-button>
									<div>
										<button
											(click)="editUserRole(availableUserRole)"
											mat-icon-button
											color="primary"
											[matTooltip]="t('billing.editUserRole')">
											<mat-icon>edit</mat-icon>
										</button>
										<button
											(click)="deleteUserRole(availableUserRole)"
											mat-icon-button
											color="primary"
											[matTooltip]="t('billing.deleteUserRole')">
											<mat-icon>delete</mat-icon>
										</button>
									</div>
								</div>
							}
						</mat-radio-group>
					</div>
					<div>
						<button mat-raised-button color="primary" (click)="syncManually()" [disabled]="!anyInstanceUnsynced()">
							<mat-icon>sync</mat-icon>
							<span>{{ t('billing.syncManually') }}</span>
						</button>
					</div>
				</div>

				<mat-list class="custom-list">
					@if (finishedLoading()) {
						@for (tenantUnitReference of filteredTenantUnitReferences(); track tenantUnitReference.exportId) {
							<mat-list-item
								class="list-item"
								[class.warn]="instanceUnsyncedByRoleFilter(tenantUnitReference)"
								[class.selected]="selectedTenantUnitReference()?.number === tenantUnitReference.number"
								(click)="selectInstance(tenantUnitReference)"
								(keyup)="selectInstance(tenantUnitReference)">
								<div class="item-content">
									<!-- Erste Zeile: Nummer, Icon und Menü -->
									<div class="item-header">
										<span class="item-number">
											{{ t('billing.tenantUnitNo') }} {{ tenantUnitReference.number }} /{{ tenantUnitReference.subNumber }}
										</span>
										@if (userRoleTypeFilter() === UserRoleTypeExtensionEnum.BILLING_UNIT) {
											<span class="item-user-small text-xs font-light">
												{{ tenantUnitReference.tenantUnitUserReferences?.at(0)?.name }}
											</span>
										}
										<div class="menu-button">
											<mat-icon
												[class]="iconHelper.getColorByInSync(!instanceUnsyncedByRoleFilter(tenantUnitReference))"
												[svgIcon]="iconHelper.getIconByInSync(!instanceUnsyncedByRoleFilter(tenantUnitReference))"></mat-icon>
											<button mat-icon-button [matMenuTriggerFor]="rowActionMenu" (click)="$event.stopPropagation()">
												<mat-icon>more_vert</mat-icon>
											</button>
										</div>
										<mat-menu #rowActionMenu="matMenu">
											<button mat-menu-item (click)="selectInstance(tenantUnitReference)">
												<mat-icon color="primary">open_in_new</mat-icon>
												<div>{{ t('commonActions.open') }}</div>
											</button>
											@if (!tenantUnitReference.inSync) {
												<button mat-menu-item (click)="reAllocateInstance(tenantUnitReference)">
													<mat-icon color="primary">replay</mat-icon>
													<div>{{ t('billing.reAllocateInstance') }}</div>
												</button>
											}
											@if (anyUserOfInstanceUnsynced(tenantUnitReference)) {
												<button mat-menu-item (click)="reAllocateUser(tenantUnitReference)">
													<mat-icon color="primary">replay</mat-icon>
													<div>{{ t('billing.reAllocateUser') }}</div>
												</button>
											}
										</mat-menu>
									</div>

									@if (userRoleTypeFilter() !== UserRoleTypeExtensionEnum.BILLING_UNIT) {
										@for (user of tenantUnitReference.tenantUnitUserReferences; track user.exportId) {
											<div class="pl-4">
												{{ user?.name }},
												<span class="item-dates">
													{{ dateUtil.setDateFormatByActiveLang(user?.validFrom, '') }} -
													{{ dateUtil.setDateFormatByActiveLang(user?.validTo, t('common.today')) }}
												</span>
											</div>
										}
									}
								</div>
							</mat-list-item>
						} @empty {
							<mat-list-item class="empty-state">
								<span>{{ t('dashboard.noDataFound') }}</span>
							</mat-list-item>
						}
					} @else {
						<mat-list-item class="empty-state">
							<mat-spinner color="primary" diameter="30" mode="indeterminate"></mat-spinner>
						</mat-list-item>
					}
				</mat-list>
			</div>
		</div>
		<div class="flex-[70%]">
			@if (!selectedTenantUnitReference()) {
				<div class="flex flex-col justify-center items-center h-[35rem]">
					<mat-icon>ads_click</mat-icon>
					{{ t('billing.selectInstanceFirst') }}
				</div>
			} @else {
				<ara-tenant-unit-reference
					[billingId]="billingId"
					[validFromFilter]="validFromFilter()"
					[validToFilter]="validToFilter()"
					[selectedInstance]="selectedTenantUnitReference()"></ara-tenant-unit-reference>
			}
		</div>
	</div>
</div>
